import { Dayjs } from 'dayjs';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { MonthCalendar, YearCalendar } from '@mui/x-date-pickers';

const CustomCalendarHeaderRoot = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px 24px 0px 24px',
  height: '24px',
  alignItems: 'center',
  color: '#000'
});

export const CalendarHeader = (props) => {
  const { currentMonth, onMonthChange } = props;

  const selectNextMonth = () => onMonthChange(currentMonth.add(1, 'month'), 'left');
  const selectNextYear = () => onMonthChange(currentMonth.add(1, 'year'), 'left');
  const selectPreviousMonth = () =>
    onMonthChange(currentMonth.subtract(1, 'month'), 'right');
  const selectPreviousYear = () =>
    onMonthChange(currentMonth.subtract(1, 'year'), 'right');
 
  return (
    <CustomCalendarHeaderRoot sx={{ display: ''}}>
      <Stack spacing={1} direction="row">
      {/* <MonthCalendar /> */}
      {/* <YearCalendar /> */}
        {/* <IconButton onClick={selectPreviousYear} title="Previous year">
          <KeyboardDoubleArrowLeftIcon />
        </IconButton> */}
        <IconButton sx={{ padding: 0 }} onClick={selectPreviousMonth} title="Previous month">
          <ChevronLeft />
        </IconButton>
      </Stack>
      <Typography className='h5-medium' sx={{ textTransform: 'capitalize' }}>{currentMonth.format('MMMM YYYY')}</Typography>
      <Stack spacing={1} direction="row">
        <IconButton sx={{ padding: 0 }} onClick={selectNextMonth} title="Next month">
          <ChevronRight />
        </IconButton>
        {/* <IconButton onClick={selectNextYear} title="Next year">
          <KeyboardDoubleArrowRightIcon />
        </IconButton> */}
      </Stack>
    </CustomCalendarHeaderRoot>
  );
}
